import images from "@/config/images";
import image from "@/constants/image";
import { EPrioritizeReport } from "./report";

export interface TableHeaderLabel {
  name: string;
  label: string;
  sortable: boolean;
  isShowColumn?: boolean;
  className?: string;
  align?: "center" | "inherit" | "justify" | "left" | "right";
}

// export interface Country {
//   formattedName: string;
//   rawName: string;
// }

export interface OptionItem<T = number> {
  id: T;
  name: string;
  title?: string;
  fullName?: string;
  translation?: any;
  img?: any;
  shortName?: string; // Thêm trường shortName
  subName?: string;
  icon?: any;
  symbol?: string;
  result?: boolean;
  isZip?: boolean;
}

export interface OptionItemT<T> {
  id: T;
  name: string;
  translation?: string;
}

export interface PaginationParams {
  take?: number;
  page?: number;
}

export interface Meta {
  take: number;
  itemCount: number;
  page: number;
  pageCount: number;
  totalColumnNew?: number;
}

export interface DataOption {
  data: OptionItem[];
  meta: Meta;
}

export class Filter {
  public take?: number;
  public page?: number;
  public keyword?: string;

  constructor(take?: number, page?: number) {
    this.take = take || 10;
    this.page = page || 1;
    this.keyword = "";
  }
}

export interface DataPagination<T> {
  data: T[];
  meta: Meta;
}

export enum SocialProvider {
  FACEBOOK = "Facebook",
  ZALO = "Zalo",
  GOOGLE = "Google",
  MICROSOFT = "MICROSOFT",
}

export interface BreadcrumbItem {
  name: string;
  routes?: string;
  outside?: boolean;
}

export enum Lang {
  VI = "vi",
  EN = "en",
  ID = "id",
}

export interface LangSupport {
  key: Lang;
  name: string;
  img: any;
}

export const langSupports: LangSupport[] = [
  {
    key: Lang.VI,
    name: "Tiếng Việt",
    img: image.iconVietNam,
  },
  {
    key: Lang.EN,
    name: "English",
    img: image.iconEN,
  },
  {
    key: Lang.ID,
    name: "Bahasa Indonesia",
    img: image.iconID,
  },
];

export const langOptions: OptionItem<string>[] = [
  {
    id: Lang.VI,
    name: "Tiếng Việt",
    img: images.imgLangVi,
  },
  {
    id: Lang.EN,
    name: "English",
    img: images.imgLangEn,
  },
  {
    id: Lang.ID,
    name: "Bahasa Indonesia",
    img: images.imgLangId,
  },
];

export const companySize: OptionItem<number>[] = [
  {
    id: 1,
    name: "<250 employees",
  },
  {
    id: 2,
    name: "250 - 500 employees",
  },
  {
    id: 3,
    name: "501 - 1,000 employees",
  },
  {
    id: 4,
    name: "5,001 - 10,000 employees",
  },
  {
    id: 5,
    name: ">10,000 employees",
  },
];
export const roleAccessProject: OptionItem<number>[] = [
  {
    id: 1,
    name: "Results viewer",
  },
  {
    id: 2,
    name: "Editor",
  },
  {
    id: 3,
    name: "Owner",
  },
];

export const DATE_FORMAT: {
  [key in Lang]: {
    fullDate: string;
    monthYear: string;
    month: string;
    year: string;
  };
} = {
  [Lang.VI]: {
    fullDate: "DD/MM/YYYY",
    monthYear: "MM/YYYY",
    month: "MMMM",
    year: "YYYY",
  },
  [Lang.EN]: {
    fullDate: "MMM DD, YYYY",
    monthYear: "MMM YYYY",
    month: "MMM",
    year: "YYYY",
  },
  [Lang.ID]: {
    fullDate: "MMM DD, YYYY",
    monthYear: "MMM YYYY",
    month: "MMM",
    year: "YYYY",
  },
};

export enum EGender {
  Female = "Nu",
  Male = "Nam",
}

export interface SortItem {
  sortedField: string;
  isDescending: boolean;
}

export enum EKey {
  TOKEN = "token",
  REFRESH_TOKEN = "refresh_token",
  BROWSER_ID = "uuid",
  TOKEN_GUEST = "token_guest",
}

export enum EStatus {
  Active = 1,
  Inactive,
  Coming_Soon,
}

export const statuses: OptionItem[] = [
  { id: EStatus.Active, name: "Active" },
  { id: EStatus.Inactive, name: "Inactive" },
];

export enum EPaymentMethod {
  CREDIT_OR_DEBIT = 1,
  INTERNET_BANKING = 2,
  BANK_TRANSFER = 3,
  MAKE_AN_ORDER = 4,
  ONEPAY_GENERAL = 5,
}

export enum EOnePayMethod {
  CREDIT_OR_DEBIT = 1,
  INTERNET_BANKING = 2,
  QR = 4,
}

export const paymentMethods: OptionItem[] = [
  { id: EPaymentMethod.CREDIT_OR_DEBIT, name: "Credit / Debit Card" },
  { id: EPaymentMethod.INTERNET_BANKING, name: "ATM card / Bank account" },
  { id: EPaymentMethod.BANK_TRANSFER, name: "Bank transfer" },
  { id: EPaymentMethod.MAKE_AN_ORDER, name: "Make an order" },
  {
    id: EPaymentMethod.ONEPAY_GENERAL,
    name: "ATM card (Internet Banking) / Credit / Debit Card",
  },
];

export enum ETypeVerifyCode {
  VERIFY_EMAIL = 1,
  RESET_PASSWORD = 2,
}

export enum ECurrency {
  USD = "USD",
  VND = "VND",
  IDR = "IDR",
}

export const currencyTypes: OptionItem<ECurrency>[] = [
  { id: ECurrency.USD, name: "$ USD", subName: "USD", symbol: "$" },
  { id: ECurrency.VND, name: "₫ VND", subName: "VND", symbol: "đ" },
  { id: ECurrency.IDR, name: "Rp IDR", subName: "IDR", symbol: "Rp" },
];

export enum EVIDEO_MARKETING_STAGE {
  POST_LAUNCH = 1,
  PRE_LAUNCH = 2,
}

export enum EOPERATION_TYPE {
  ADD = 1,
  SUBTRACT = 2,
}

export const operationTypes: OptionItem[] = [
  { id: EOPERATION_TYPE.ADD, name: "Add" },
  { id: EOPERATION_TYPE.SUBTRACT, name: "Subtract" },
];

export enum EmailTemplates {
  VERIFY_EMAIL = 2,
}

export const delayEmailSeconds: { [key: string | number]: number } = {
  [EmailTemplates.VERIFY_EMAIL]: 60,
};

export interface PagingParams {
  take?: number;
  page: number;
}

export const _paramsPagination: PagingParams = {
  take: 10,
  page: 1,
};
export const currencySymbol = {
  [ECurrency.USD]: {
    first: "US$ ",
    last: "",
  },
  [ECurrency.VND]: {
    first: "",
    last: "₫",
  },
  [ECurrency.IDR]: {
    first: "Rp ",
    last: "",
  },
};

export enum visualType {
  SLICER = "slicer",
}
export enum TYPE_NEED_HELP {
  PAYMENT = 1,
  SUBSCRIPTION = 2,
  TECHNICAL = 3,
}

export const EPrioritizeReportList = [
  { id: EPrioritizeReport.PDF, name: "PDF" },
  { id: EPrioritizeReport.POWERBI, name: "Power BI" },
  { id: EPrioritizeReport.EMBED, name: "Embed" },
];
